import React from 'react'
import { LucideIcon } from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '../ui'

interface StepCardProps {
 title: string
 icon?: LucideIcon
 children: React.ReactNode
 description?: string
}

export const StepCard: React.FC<StepCardProps> = ({
 title,
 icon: Icon,
 children,
 description
}) => {
 return (
 <Card>
 <CardHeader>
 <CardTitle className="flex items-center">
 {Icon && <Icon className="h-5 w-5 mr-2 text-accent" />}
 {title}
 </CardTitle>
 {description && (
 <p className="text-sm text-muted-foreground mt-1">
 {description}
 </p>
 )}
 </CardHeader>
 <CardContent className="space-y-4">
 {children}
 </CardContent>
 </Card>
 )
}

